<!--<p fxLayout="row" fxLayoutAlign="start center">
  <label fxFlex="30" fxShow fxHide.xs>{{label}}</label>
   <span fxFlex.gt-xs="50" fxFlex.xs="100"> 
  <button fxFlex.xs="100" fxFlex.gt-xs="none" class="mybutton" [disabled]="disabled"><ng-content></ng-content></button>
   </span>
</p>-->

<div class="container">
  <div class="row">
    <!-- Spacer column that aligns the button under the field on desktop. It is
         empty, so it is hidden below 768px rather than stacked, which would
         otherwise add a blank row above every button on mobile. -->
    <div class="d-none d-md-block col-md-4">
      <label></label>
    </div>
    <div class="col-12 col-md-5">
      <button class="mybutton" [disabled]="disabled"><ng-content></ng-content></button>
    </div>
  </div>
</div>


<!-- <p fxLayout="row" fxLayoutAlign="start center">
  <label fxFlex="30" fxShow fxHide.xs>{{label}}</label>
  <button fxFlex.xs="100" fxFlex.gt-xs="none" mat-raised-button [color]="color" [disabled]="disabled"><ng-content></ng-content></button>
</p> -->

